"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _newid = _interopRequireDefault(require("../../utils/newid"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  options: [],
  placeholder: 'Filter by',
  onOptionChange: function onOptionChange() {},
  onClear: function onClear() {},
  showClearButton: true
};
function findSelected(selectedOption, options) {
  var selected = {};
  try {
    selected = options.filter(function (option) {
      return option.key === selectedOption.key;
    })[0];
    return selected;
  } catch (e) {
    return undefined;
  }
}

/**
 * Used for selecting a specific filter from a collection
 */
var Filter = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Filter, _React$Component);
  function Filter(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Filter);
    _this = _callSuper(this, Filter, [props]);
    _this.filterCheckbox = {};
    _this.filterLabel = {};
    _this.filterRef = {};
    _this.state = {
      selected: findSelected(props.selectedOption, props.options)
    };
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFilterKeydown = _this.handleFilterKeydown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleCheckbox = _this.toggleCheckbox.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkboxId = _this.props.checkboxId || (0, _newid["default"])('filter-checkbox-');
    _this.optionRefs = {};
    if (typeof window !== 'undefined') {
      document.body.addEventListener('click', function (event) {
        if (_this.filterCheckbox && event.target !== _this.filterLabel && event.target !== _this.filterCheckbox) {
          _this.filterCheckbox.checked = false;
        }
      });
    }
    return _this;
  }
  (0, _createClass2["default"])(Filter, [{
    key: "toggleCheckbox",
    value: function toggleCheckbox() {
      this.filterCheckbox.checked = !this.filterCheckbox.checked;
    }
  }, {
    key: "moveOptionFocus",
    value: function moveOptionFocus(_ref) {
      var from = _ref.from,
        next = _ref.next;
      var options = this.props.options;
      var index = options.indexOf(options.find(function (o) {
        return o.key === from.key;
      }));
      var indexToFocus = next(index, options);
      this.optionRefs[options[indexToFocus].key].focus();
    }
  }, {
    key: "handleFilterKeydown",
    value: function handleFilterKeydown(e, currentSelection) {
      if (e.key !== 'Enter') return;
      this.toggleCheckbox();
      if (!this.filterCheckbox.checked) return;
      if (currentSelection) {
        this.optionRefs[currentSelection.key].focus();
      } else {
        this.optionRefs[this.props.options[0].key].focus();
      }
    }
  }, {
    key: "handleOptionNavigation",
    value: function handleOptionNavigation(e, option) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.moveOptionFocus({
          from: option,
          next: function next(index, options) {
            return index === options.length - 1 ? 0 : index + 1;
          }
        });
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.moveOptionFocus({
          from: option,
          next: function next(index, options) {
            return index === 0 ? options.length - 1 : index - 1;
          }
        });
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this2 = this;
      var onClear = this.props.onClear;
      this.setState({
        selected: undefined
      }, function () {
        _this2.filterCheckbox.checked = false;
        _this2.filterRef.focus();
        onClear();
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(option) {
      var _this3 = this;
      var onOptionChange = this.props.onOptionChange;
      this.setState({
        selected: option
      }, function () {
        _this3.filterCheckbox.checked = false;
        _this3.filterRef.focus();
        onOptionChange({
          value: option
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        className = _this$props.className,
        testId = _this$props.testId,
        placeholder = _this$props.placeholder,
        options = _this$props.options,
        theme = _this$props.theme,
        value = _this$props.value,
        ariaLabel = _this$props['aria-label'],
        showClearButton = _this$props.showClearButton,
        selectedOption = _this$props.selectedOption;
      var selected = this.state.selected;
      var currentSelection = 'value' in this.props ? value : selectedOption || selected;
      var isSelectionValid = currentSelection && findSelected(currentSelection, options);
      var classes = (0, _classnames["default"])(theme.filter, /* themeCSSlocalized styles */
      className /* user specified classNames */);
      var labelClasses = (0, _classnames["default"])(theme.label, isSelectionValid ? theme.selected : '');
      var renderedLabel;
      if (isSelectionValid) {
        renderedLabel = currentSelection.text || currentSelection.value;
      } else {
        renderedLabel = placeholder;
      }

      /* eslint-disable jsx-a11y/label-has-for */
      return (
        /*#__PURE__*/
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        _react["default"].createElement("div", {
          role: "listbox",
          className: classes,
          tabIndex: "0",
          onKeyDown: function onKeyDown(e) {
            return _this4.handleFilterKeydown(e, currentSelection);
          },
          ref: function ref(l) {
            _this4.filterRef = l;
          },
          "data-test-id": testId,
          "data-anypoint-component": Filter.displayName,
          "aria-activedescendant": currentSelection && "filter-option-".concat(currentSelection.key),
          "aria-label": ariaLabel
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: labelClasses,
          id: "filterLabel",
          "data-test-id": testId && "".concat(testId, "-filter-label-group"),
          ref: function ref(l) {
            _this4.filterLabel = l;
          }
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: theme.selectedLabel,
          htmlFor: this.checkboxId
        }, /*#__PURE__*/_react["default"].createElement("div", {
          "data-test-id": testId && "".concat(testId, "-filter-label-selected")
        }, renderedLabel), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: theme.filterIcon,
          name: "arrow-down-small",
          size: "",
          isDecorative: true
        }))), /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          id: this.checkboxId,
          "data-test-id": testId && "".concat(testId, "-filter-checkbox"),
          ref: function ref(f) {
            _this4.filterCheckbox = f;
          },
          className: theme.filterCheckbox
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.dropdown,
          "data-test-id": testId && "".concat(testId, "-filter-dropdown")
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.dropdownHeader,
          "data-test-id": testId && "".concat(testId, "-filter-dropdown-header")
        }, showClearButton ? /*#__PURE__*/_react["default"].createElement("label", {
          "data-test-id": testId && "".concat(testId, "-filter-dropdown-placeholder"),
          htmlFor: this.checkboxId
        }, placeholder) : /*#__PURE__*/_react["default"].createElement("label", {
          style: {
            cursor: 'pointer'
          },
          "data-test-id": testId && "".concat(testId, "-filter-dropdown-placeholder"),
          onClick: this.handleClear
        }, placeholder), showClearButton ? /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: this.handleClear,
          "data-test-id": testId && "".concat(testId, "-filter-clear-button")
        }, "clear") : null), /*#__PURE__*/_react["default"].createElement("ul", {
          "data-test-id": testId && "".concat(testId, "-filter-options")
        }, options.map(function (option, index) {
          var isSelected = currentSelection && currentSelection.key === option.key;
          var isUserFocusable = isSelected || !currentSelection && index === 0;
          var handleSelect = function handleSelect() {
            return _this4.handleChange(currentSelection && currentSelection.key === option.key ? undefined : option);
          };
          var handleOptionKeydown = function handleOptionKeydown(e) {
            if (e.key === 'Enter') {
              handleSelect();
            }
            return _this4.handleOptionNavigation(e, option);
          };
          /* eslint-disable jsx-a11y/no-static-element-interactions */
          return /*#__PURE__*/_react["default"].createElement("li", {
            role: "option",
            className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, theme.active, isSelected)),
            "aria-selected": isSelected,
            ref: function ref(f) {
              _this4.optionRefs[option.key] = f;
            },
            key: option.key,
            id: "filter-option-".concat(option.key),
            "data-test-id": testId && "".concat(testId, "-filter-option-").concat(option.key),
            tabIndex: isUserFocusable ? '0' : '-1',
            "aria-posinset": index + 1,
            "aria-setsize": options.length,
            onClick: handleSelect,
            onKeyDown: handleOptionKeydown
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: "option-icon"
          }, isSelected ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            name: "check-small",
            size: "xs",
            className: option.iconClassName
          }) : null), option.value.type || option.value.$$typeof ? option.value : /*#__PURE__*/_react["default"].createElement("span", null, option.value));
        }))))
      );
    }
  }]);
  return Filter;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Filter, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Filter, "displayName", 'Filter');
//# sourceMappingURL=Filter.js.map